import { Component } from '@angular/core';
import {Router} from '@angular/router';
import 'jquery-slimscroll';
import {TaskService} from "../../../services/task.service";
import {TranslateService} from "@ngx-translate/core";
import { environment } from 'environments/environment';

declare var jQuery:any;

@Component({
  selector: 'navigation',
  templateUrl: 'navigation.template.html',
    styleUrls: ['navigation.component.css']
})

export class NavigationComponent {

  constructor(private router: Router, private _translate: TranslateService) {}

  ucloudBackdoor = environment.ucloudBackdoor.concat("/#/dashboard")
      .concat("?ucloud=").concat(sessionStorage.getItem("token_ucloud"))
      .concat("&username=").concat(localStorage.getItem("username_ucloud"))
      .concat("&umove=").concat(localStorage.getItem("token_umotion"));

      ngAfterViewInit() {
        jQuery('#side-menu').metisMenu();

        if (jQuery("body").hasClass('fixed-sidebar')) {
          jQuery('.sidebar-collapse').slimscroll({
            height: '100%'
          })
        }
      }

  activeRoute(routename: string): boolean{
    return this.router.url.indexOf(routename) > -1;
  }

  getUCloudToken() {
    return !!sessionStorage.getItem("token_ucloud");
  }
}
